import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import StorePage from 'components/Store/StorePage';
import Table from 'components/Table/Table';
import React, { useEffect } from "react";
import Button from 'react-bootstrap/Button';
import { useDispatch, useSelector } from 'react-redux';
import { loadServices } from 'store/actions/schedulingActions';
import { Route, Switch } from "util/router.js";
import * as moment from 'moment-timezone'
import ReactTable from "react-table";
import { IconButton } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Modal from 'react-bootstrap/Modal'
import {DeleteServiceButton, DuplicateServiceButton, EditServiceButton, NewServiceButton} from 'components/Store/ServiceButton'

function ServiceActions(props) {
    const {service} = props
    const instructor = useSelector(state => state.instructor.instructor)

    const [showCode, setShowCode] = React.useState(false)

    return (
    <div className={'d-flex flex-row-reverse'}>
        <Modal 
        close
        show={showCode}
        onHide={() => setShowCode(false)}
        >
            <Modal.Header closeButton>
                Embeddable scheudle for {service.name}
            </Modal.Header>
            <Modal.Body>
            <pre>
                        <code>
                            {(`<iframe
id="sutraWidgetIframe"
src="https://sutrapro.com/iframe/${instructor.widgetName}/schedule?template=${service.id}"
width="100%"
frameBorder="0"
allowfullscreen></iframe>
<script src="https://sutrapro.com/scripts/embed.js"></script>`)}
                        </code>
                    </pre>
                
            </Modal.Body>

        </Modal>
        <DeleteServiceButton
        {...props}
        toDelete={service}
        new
        />
        <EditServiceButton
        {...props}
        toEdit={service}
        new
        />
        <DuplicateServiceButton
        {...props}
        toDuplicate={service}
        />
        {/* trap vibes */}
        {['LlWONweec2zxsYBYjaup', 'tP32UlqRXaaiHvhD6hlO2ShnzaD3'].includes(instructor.id) && (

            <IconButton onClick={() => {
                setShowCode(true)
            }}>
                <VisibilityIcon/>    
            </IconButton>
        )}
    </div>
    );
}
function ServicesTable(props) {

    var instructor_classes = useSelector(state => state.instructor.classes);
    

    const upcomingClassesByServiceId = instructor_classes.filter(val => {
        return (val.start_time) > moment().unix();
    }).reduce((map, cls) => {
        if (cls.service_id) {
            if (map[cls.service_id]) {
                map[cls.service_id] = map[cls.service_id] + 1
            } else {
                map[cls.service_id] = 1
            }
        }
        return map
    }, {}) 


    

    const viewModel = {
        classes: props.services.filter(val => val.experience_type.toLowerCase() === "class").map(val => {
            return {
                name: val.name,
                upcoming: (upcomingClassesByServiceId[val.id] ? `${upcomingClassesByServiceId[val.id]} Upcoming` : "Not Scheduled"),
                actions: (<ServiceActions service={val} />)
            }
        }),
        events: props.services.filter(val => val.experience_type.toLowerCase() === "event").map(val => {
            return {
                name: val.name,
                upcoming: (upcomingClassesByServiceId[val.id] ? `${upcomingClassesByServiceId[val.id]} Upcoming` : "Not Scheduled"),
                actions: (<ServiceActions service={val} />)
            }
        }),
        workshops: props.services.filter(val => val.experience_type.toLowerCase() === "workshop").map(val => {
            return {
                name: val.name,
                upcoming: (upcomingClassesByServiceId[val.id] ? `${upcomingClassesByServiceId[val.id]} Upcoming` : "Not Scheduled"),
                actions: (<ServiceActions service={val} />)
            }
        }),
        privates: props.services.filter(val => val.experience_type.toLowerCase() === "appointment").map(val => {
            return {
                name: val.name,
                upcoming: (upcomingClassesByServiceId[val.id] ? `${upcomingClassesByServiceId[val.id]} Upcoming` : "Not Scheduled"),
                actions: (<ServiceActions service={val} />)
            }
        })
    }

    console.log(viewModel.services)

    const columns = [
        {
            accessor: "name",
            minWidth: 100,
            Cell: row => (
                <h6>{row.value}</h6>
            )
        },
        {
            accessor: "upcoming"
        },
        {
            accessor: "actions",
            width: 250
        }
    ]

//     name
// upcoming
// actions

    return (
        <GridContainer>
            <GridItem xs={12}>
                <h4>Classes</h4>
                <ReactTable
                className="mb-5"
                data={viewModel.classes}
                pageSize={viewModel.classes.length ?? 0}
                showPagination={false}
                sortable={false}
                filterable={false}
                columns={columns}
                />
                
                {/* <Table
                tableData={viewModel.classes.length > 0 ? viewModel.classes : [["Click 'Add New' to add a class"]]}
                /> */}
            </GridItem>
            <GridItem xs={12}>
                <h4>Events</h4>
                <ReactTable
                className="mb-5"
                data={viewModel.events}
                pageSize={viewModel.events.length ?? 0}
                showPagination={false}
                sortable={false}
                filterable={false}
                columns={columns}
                />
            </GridItem>
            <GridItem xs={12}>
                <h4>Workshops</h4>
                <ReactTable
                className="mb-5"
                data={viewModel.workshops}
                pageSize={viewModel.workshops.length ?? 0}
                showPagination={false}
                sortable={false}
                filterable={false}
                columns={columns}
                />
            </GridItem>
            <GridItem xs={12}>
                <h4>Privates</h4>
                <ReactTable
                className="mb-5"
                data={viewModel.privates}
                pageSize={viewModel.privates.length ?? 0}
                showPagination={false}
                sortable={false}
                filterable={false}
                columns={columns}
                />
            </GridItem>
            {/* <GridItem xs={12}>
                <h4>Teacher Trainings</h4>
                <Table
                tableData={viewModel.trainings.length > 0 ? viewModel.trainings : [["Click 'Add New' to add a teacher training"]]}
                />
            </GridItem> */}
        </GridContainer>
    );

}

function ThisStore(props) {

    const user = useSelector(state => state.user.userData)
    const services = useSelector(state => state.scheduling.services)

    console.log("Services")
    console.log(services)
    const dispatch = useDispatch();
    useEffect(() => {

        if (user.platformID) { //&& (services == null || services.length == 0)
            console.log("Loading Services")
            dispatch(loadServices());
        }

        // console.log("Loading Services")
        // dispatch(loadServices());  
        
    }, [user, dispatch]);
    //   }, [user, services]);


    const { history, match } = props;
    
    function onAddNew() {
        history.push(`${match.url}/create`)
    }

    function onEditService(service) {
        console.log("edit service")
        // props.setExistingService(service)
        // console.log(`${match.url}/edit/${service.platformID}`)
        history.push(`${match.url}/edit/${service.platformID}`)
    }

    function onDuplicateService(service) {
        console.log("duplicate service")
        history.push(`${match.url}/duplicate/${service.platformID}`)
    }

    function onAddClass(service) {
        console.log("add class with service")
        history.push(`${match.url}/create/${service.platformID}`)
    }

    return (
        <div>
            <div className='d-flex d-row justify-content-between align-items-center mb-4'>
                <div className="d-flex d-row align-items-center">
                    <h2 className="font-weight-bold">Templates</h2>
                </div>
                
                <NewServiceButton className="float-right" {...props}/> 

                {/* <NavLink href='/dashboard/schedule'>View More</NavLink> */}
                </div>
            <ServicesTable
            onEditService={onEditService}
            onDuplicateService={onDuplicateService}
            onAddClass={onAddClass}
            services={services}
             {...props} />

        </div>
    )
}

function Services(props) {
    const { history, match } = props;

    const [existingService, setExistingService] = React.useState(null);

    return (
        <Switch>
            {/* <Route 
                path={`${match.url}/class/:platformID`} 
                render={props => {
                return <ClassDashboard {...props}/>
                }} 
            /> */}
            
            {/* <Route 
            path={`${match.url}/edit/:service_id`} 
            render={props => {
                return <ServiceEditor
                {...props}
                sendingUrl={match.url}
                editMode={true}
                // existingService={existingService}
                />
            }} 
            />
             <Route 
            path={`${match.url}/duplicate/:service_id`} 
            render={props => {
                return <ServiceEditor
                {...props}
                sendingUrl={match.url}
                duplicateMode={true}
                // existingService={existingService}
                />
            }} 
            />
            <Route 
            path={`${match.url}/create/:service_id`} 
            render={props => {
                return <ServiceEditor 
                {...props}
                sendingUrl={match.url}
                existing={true} // edit existing service.. 
                />
            }} 
            />
            <Route 
            path={`${match.url}/create`} 
            render={props => {
                return <ServiceEditor 
                {...props}
                sendingUrl={match.url}/>
            }} 
            /> */}
            <Route path="/">
                <ThisStore 
                setExistingService={setExistingService}
                {...props} />
            </Route>

        </Switch>
    );
}

export default Services;